import { useMutation, useQueryClient } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { updateOptInFeature } from '../Services/OptInFeatures.service';
import type { OptInFeatureUpdatePayload } from '../Types/OptInFeatures.types';
import { useActionToast } from '@/Hooks/useActionToast';

export const useUpdateOptInFeature = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: OptInFeatureUpdatePayload }) =>
      updateOptInFeature(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: optInFeaturesQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: optInFeaturesQueryKeys.details() });
      toast.success('Funcionalidade salva');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível salvar a funcionalidade', error);
    },
  });
};
